import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Skeleton, Tooltip } from 'antd';
import { FaEdit } from 'react-icons/fa';
import useTheme from 'src/hooks/useTheme';

const { Paragraph } = Typography;

const PropertyItem = ({ label, labelExtras, value, secondValue, copyable, loading, onClick, isHighlighted }) => {
  const { theme } = useTheme();

  return (
    <div className={`${isHighlighted ? 'border-2 border-dashed border-red-500 dark:border-red-500' : 'border border-solid border-gray-200 dark:border-gray-800'} rounded-xl flex flex-row overflow-hidden`}>
      <div className='flex-auto py-1 px-3'>
        <div className='flex flex-row flex-wrap gap-2 text-xs'>
          <div className='font-semibold opacity-60'>{label ?? 'Unknown property'}</div>
          {labelExtras && <div>{labelExtras}</div>}
        </div>
        {loading ? (
          <div className='text-right block'>
            <Skeleton.Input active={true} size={24} />
          </div>
        ) : (
          <>
            <div className='text-right block'>
              <Paragraph style={{ margin: '0' }} copyable={copyable}>
                <div className='text-ellipsis text-[0.8rem] '>{value ?? 'n/a'}</div>
              </Paragraph>
            </div>
            {secondValue && (
              <div className='text-right block'>
                <Paragraph style={{ margin: '0' }} copyable={copyable}>
                  <div className='font-light text-ellipsis text-[0.6rem] opacity-60'>{secondValue}</div>
                </Paragraph>
              </div>
            )}
          </>
        )}
      </div>
      {onClick && (
        <Tooltip title='Click to edit'>
          <div className={'w-12 rounded-r-lg flex flex-row justify-center items-center hover:opacity-90 cursor-pointer'} style={{ backgroundColor: theme.primary }} onClick={onClick}>
            <FaEdit className='text-white text-lg' />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

PropertyItem.propTypes = {
  label: PropTypes.any,
  labelExtras: PropTypes.any,
  value: PropTypes.any,
  secondValue: PropTypes.any,
  copyable: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  isHighlighted: PropTypes.bool,
};

export default PropertyItem;
